import { css } from '@emotion/react';

import { colors } from '../../styles/colors';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
export const headingContainer = css`
  display: flex;
  padding-bottom: 24px;
`;

export const backBtn = css`
  color: ${colors.white};
  margin-right: 8px;
  cursor: pointer;
`;
export const headerText = css`
  color: ${colors.NewSubscriptionCouponText};
  ${ZeeFontBold(16, 18)};
`;
export const inputContainer = css`
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 6px;
`;
export const inputText = css`
  flex: 1;
`;
export const codeInput = css`
  color: ${colors.greyText};
  font-size: 12px;
  line-height: 18px;
  background: ${colors.AppBgColor};
  border: 0;
  outline: 0;
  width: 95%;
`;
export const applyCodePopUpWrapper = css`
  height: 150px;
  ${MQ.MediaMd} {
    height: 200px;
  }
`;
export const applyBtnContainer = css`
  ${ZeeFontMedium(14, 18)}
  color: ${colors.PurpleLight};
  cursor: pointer;
`;

export const errorMessage = css`
  color: ${colors.AccentPromoCodeFailureColor};
  ${ZeeFontRegular(12, 18)}
  padding: 6px 0 6px;
`;

export const error = css`
  color: ${colors.AccentPromoCodeFailureColor};
`;
